export default {
  props: {
    value: { required: false },
    state: { type: Boolean },
    errors: { type: Array },
    dirty: { type: Boolean, default: false },
  },

  methods: {
    focus() {
      if (this.$refs.input) this.$refs.input.focus()
    },
  }
}